import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { toast } from 'sonner';
import { courierKeys, mapCourierError, useTranslation } from '@dukanti/shared';
import { resendCourierVerification } from '@dukanti/shared/services';
import type { CourierVerificationResult, TranslationKey } from '@dukanti/shared';
import { supabase } from '@/lib/supabase';

export function useResendCourierVerification(
  storeId: string,
): UseMutationResult<CourierVerificationResult, unknown, string> {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation<CourierVerificationResult, unknown, string>({
    mutationFn: (courierId) => resendCourierVerification(supabase, { storeId, courierId }),
    onSuccess: (result) => {
      void queryClient.invalidateQueries({ queryKey: courierKeys.list(storeId) });
      if (!result.success) {
        toast.error(t(mapCourierError(undefined, result) as TranslationKey));
        return;
      }
      toast.success(
        t('admin.couriers.verification.sent' as TranslationKey, {
          phone: result.courier?.phone_number ?? '',
        }),
      );
    },
    onError: (err) => {
      toast.error(t(mapCourierError(err) as TranslationKey));
    },
  });
}
